import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  cursor: pointer;
`;

type ContentProps = {
  $isPlusPage: boolean;
};

export const Content = styled.div<ContentProps>`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};

  opacity: ${({ $isPlusPage }) => ($isPlusPage ? 0.7 : 1)};
`;

export const BoldWord = styled.span`
  color: #000000;
  font-weight: 700;
`;

export const Checkbox = styled.div`
  display: flex;
`;
